import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import constants from "../../assets/constants.js";
import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import PortalNavDrawer from "../ui/portalNavDrawer";
import BotpressConversations from "../widgets/botpressConversations";
import BotpressConversationsAnalytics from "../widgets/botpressConversationsAnalytics.js";
import BotpressFlaggedConversations from "../widgets/botpressFlaggedConversations.js";
import BotpressUserFeedback from "../widgets/botpressUserFeedback.js";

const BotpressConversationPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Conversations" botpressStyle={true} />
      <PortalNavDrawer />
      <PortalGridContent hasNavDrawer>
        <Grid size={{ xs: 12, lg: 7 }}>
          <BotpressConversationsAnalytics
            botpressGraphType={constants.botpressGraphTypes.conversationTopicsGraph}
            colorIndex={0}
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 5 }}>
          <BotpressConversationsAnalytics
            botpressGraphType={constants.botpressGraphTypes.conversationSentimentGraph}
            colorIndex={0}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <BotpressConversations />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <BotpressUserFeedback />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <BotpressFlaggedConversations />
        </Grid>
        <Grid size={{ xs: 12 }} />
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressConversationPortal);
